import axios from "axios";
import api from "@/services/api";

const plainAxios = axios.create();

type VehicleDocumentPresignedUrlPayload = {
	vehicleId: string;
	fileName: string;
	contentType: string;
	file: File;
	type: number;
	paymentDate?: string;
	description?: string | undefined;
	renewalDate?: string;
	documentId?: string;
};

type PresignedUrlResponse = {
	fileName: string;
	contentType: string;
	uploadUrl: string;
	filePath: string;
};

type VehicleDocumentUploadPayload = {
	vehicleId: string;
	type: number;
	fileName: string;
	fileKey?: string;
	paymentDate?: string;
	renewalDate?: string;
	description?: string;
	documentId?: string;
};

export const vehicleDocumentPresignedUrl = async (
	payload: VehicleDocumentPresignedUrlPayload
) => {
	const { vehicleId, ...rest } = payload;

	if (!rest.file) {
		return Promise.resolve();
	}
	const { data: presignedUrlResponse } = await api.post<PresignedUrlResponse>(
		`/api/vehicles/${vehicleId}/documents/presigned`,
		rest
	);

	if (!presignedUrlResponse) {
		throw new Error("Presigned URL not found");
	}

	const { uploadUrl, filePath, fileName, contentType } = presignedUrlResponse;

	const { data } = await plainAxios.put(uploadUrl, rest.file, {
		headers: { "Content-Type": contentType },
	});

	return { filePath, fileName, ...data };
};

export const vehicleDocumentUpload = async (
	payload: VehicleDocumentUploadPayload
) => {
	const { vehicleId, documentId, ...rest } = payload;
	const url = documentId
		? `/api/vehicles/${vehicleId}/documents/${documentId}`
		: `/api/vehicles/${vehicleId}/documents`;
	const method = documentId ? "put" : "post";

	const { data } = await api[method](url, rest);

	return data;
};

export const vehicleDocumentReplace = async (
	vehicleId: string,
	documentId: string
) => {
	const { data } = await api.put(
		`/api/vehicles/${vehicleId}/documents/${documentId}`
	);
	return data;
};
